// custom-sidebar.js

// document.addEventListener("DOMContentLoaded", function() {
//   jQuery(function($) {
//      // Remove inline styles and rely on classes
//     $('.dropdown-submenu .dropdown-menu').removeAttr('style');
//     // Ensure only active path is open on load
//     $('.dropdown-submenu.active').siblings().removeClass('active').children('.dropdown-menu').hide();

//     // Toggle submenu on expand click
//     $('.menu_list-ui').on('click', '.expand', function(e) {
//       e.preventDefault();

//       var parentItem = $(this).closest('.dropdown-submenu');

//       // Close siblings
//       parentItem.siblings('.dropdown-submenu')
//         .removeClass('active')
//         .children('.dropdown-menu').slideUp();

//       // Toggle this one
//       parentItem.toggleClass('active')
//         .children('.dropdown-menu').slideToggle();
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", function() {
  jQuery(function($) {
    $('.dropdown-submenu.active').siblings()
      .removeClass('active');

    $('.menu_list-ui').on('click', '.expand', function(e) {
      e.preventDefault();
      var parentItem = $(this).closest('.dropdown-submenu');
      
      // Close siblings
      parentItem.siblings('.dropdown-submenu').removeClass('active');
      
      // Toggle this one
      parentItem.toggleClass('active');
    });
  });
});